<mat-action-list>
  @for (item of items; track item) {
    <mat-list-item
      (click)="clickItem(item)">
      @if (item.icon) {
        <mat-icon
        matListItemIcon>{{ item.icon }}</mat-icon>
      }
      <span matListItemTitle
        class="headline">
        {{ item.titleI18n | translate }}
      </span>
      @if (item.subtitleI18n) {
        <span matLine
          class="subtitle"
          >
          {{ item.subtitleI18n | translate }}
        </span>
      }
    </mat-list-item>
  }
</mat-action-list>
